import { render, staticRenderFns } from "./MiniNoticia.vue?vue&type=template&id=ad29f9ce&scoped=true"
import script from "./MiniNoticia.vue?vue&type=script&lang=js"
export * from "./MiniNoticia.vue?vue&type=script&lang=js"
import style0 from "./MiniNoticia.vue?vue&type=style&index=0&id=ad29f9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad29f9ce",
  null
  
)

export default component.exports